import { Download } from "lucide-react";
import { VISION, visionMarkdown } from "@/content/vision";
import { BrandMark } from "@/components/BrandMark";

const download = () => {
  const blob = new Blob([visionMarkdown()], { type: "text/markdown" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = "Outbound-Vision-and-Strategy.md";
  a.click();
  URL.revokeObjectURL(a.href);
};

const Block = ({ b }) => {
  if (b.h) return <h3 className="text-lg sm:text-xl font-semibold text-stone-900 mt-8 mb-2">{b.h}</h3>;
  if (b.ul) return <ul className="list-disc pl-5 space-y-1.5 text-stone-700 leading-relaxed">{b.ul.map((x) => <li key={x}>{x}</li>)}</ul>;
  if (b.quote) return <blockquote className="border-l-4 border-[#2F7D55] pl-5 py-1 text-xl sm:text-2xl font-semibold text-stone-900 leading-snug" style={{ fontFamily: "Outfit" }}>{b.quote}</blockquote>;
  return <p className="text-stone-700 leading-relaxed">{b.p}</p>;
};

export default function Vision() {
  return (
    <div className="max-w-6xl mx-auto px-5 py-10 lg:py-14 grid lg:grid-cols-[230px_1fr] gap-10" data-testid="vision-page">
      <aside className="hidden lg:block">
        <nav className="sticky top-24 space-y-1 text-sm" data-testid="vision-toc">
          {VISION.sections.map((s, i) => (
            <a key={s.id} href={`#${s.id}`} className="block py-1 text-stone-500 hover:text-[#23603F]"><span className="font-mono text-xs mr-2">{String(i + 1).padStart(2, "0")}</span>{s.title}</a>
          ))}
        </nav>
      </aside>
      <article className="max-w-3xl">
        <div className="flex items-center gap-3"><BrandMark size={44} /><p className="font-mono text-xs uppercase tracking-[0.2em] text-[#23603F]">Vision & strategy · Phase 1</p></div>
        <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]">{VISION.title}</h1>
        <p className="mt-4 text-lg text-stone-600">{VISION.subtitle}</p>
        <div className="mt-6 flex flex-wrap items-center gap-4">
          <button data-testid="vision-doc-download-btn" onClick={download} className="flex items-center gap-2 bg-[#2F7D55] hover:bg-[#23603F] text-white font-semibold px-5 py-2.5 rounded-xl transition-colors active:scale-95">
            <Download className="w-4 h-4" /> Download (Markdown)
          </button>
          <span className="text-sm text-stone-500">Founder: {VISION.founder}</span>
        </div>
        {VISION.sections.map((s, i) => (
          <section key={s.id} id={s.id} className="mt-14 scroll-mt-24 space-y-4" data-testid={`vision-section-${s.id}`}>
            <p className="font-mono text-xs text-[#23603F]">{String(i + 1).padStart(2, "0")}</p>
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight -mt-2">{s.title}</h2>
            {s.blocks.map((b, j) => <Block key={j} b={b} />)}
          </section>
        ))}
      </article>
    </div>
  );
}
